export const prefixes = [
  { key: 'Mr', value: 'Mr' },
  { key: 'Miss', value: 'Miss' },
  { key: 'Mrs', value: 'Mrs' },
  { key: 'Ms', value: 'Ms' },
  { key: 'Dr', value: 'Doctor' },
  { key: 'Adm', value: 'Admiral' },
  { key: 'Atty', value: 'Attorney' },
  { key: 'Brother', value: 'Brother' },
  { key: 'Capt', value: 'Captain' },
  { key: 'Chief', value: 'Chief' },
  { key: 'Cmdr', value: 'Commander' },
  { key: 'Col', value: 'Colonel' },
  { key: 'Dean', value: 'University Dean' },
  { key: 'Elder', value: 'Elder' },
  { key: 'Father', value: 'Father' },
  { key: 'Gen', value: 'General' },
  { key: 'Gov', value: 'Governor' },
  { key: 'Hon', value: 'Honorable' },
  { key: 'Lt Col', value: 'Lieutenant Colonel' },
  { key: 'Maj', value: 'Major' },
  { key: 'MSgt', value: 'Major/Master Sergeant' },
  { key: 'Prince', value: 'Prince' },
  { key: 'Prof', value: 'Professor' },
  { key: 'Rabbi', value: 'Rabbi' },
  { key: 'Rev', value: 'Reverend' },
  { key: 'Sister', value: 'Sister' },
];
